var map = {
	"./ahold.png": 78397,
	"./albertsons.png": 83530,
	"./aldi.png": 45031,
	"./amazon.png": 25216,
	"./brookshirescompany.png": 66961,
	"./centralmarket.png": 4122,
	"./costco.png": 3629,
	"./fairwaymarket.png": 88807,
	"./fareway.png": 66529,
	"./festivalfoods.png": 94901,
	"./foodlion.png": 25594,
	"./foodtown.png": 254,
	"./freshdirect.png": 58571,
	"./giantfood.png": 25370,
	"./giantfoodstores.png": 36913,
	"./hannaford.png": 80933,
	"./harmons.png": 81323,
	"./harveys.png": 98144,
	"./heb.png": 66904,
	"./hyvee.png": 53401,
	"./ingles.png": 94020,
	"./kroger.png": 6760,
	"./loblaws.png": 30315,
	"./lowesfoods.png": 85889,
	"./lundsbyerlys.png": 66366,
	"./marketbasket.png": 89466,
	"./meijer.png": 50328,
	"./metro.png": 36898,
	"./missinglogo.png": 59469,
	"./pigglywiggly.png": 76748,
	"./publix.png": 84558,
	"./raleys.png": 53988,
	"./randalls.png": 93166,
	"./rochebros.png": 4729,
	"./safeway.png": 40980,
	"./saveonfoods.png": 8233,
	"./schnucks.png": 72349,
	"./sendiks.png": 85933,
	"./shoprite.png": 48913,
	"./spartannash.png": 49703,
	"./sprouts.png": 44843,
	"./stopshop.png": 10940,
	"./target.png": 54252,
	"./thefreshmarket.png": 3894,
	"./unitedsupermarkets.png": 51858,
	"./voila.png": 49068,
	"./walmart.png": 74186,
	"./wegmans.png": 7389,
	"./wholefoods.png": 94383,
	"./winndixie.png": 30025
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18556;